import { ReducedUser } from '@/modules/User/interfaces/user'
import { Account } from '@/modules/Account/interfaces/account'
import { Case } from '@/modules/Case/interfaces/case'
import { Policy } from '@/modules/Policy/interfaces/policy'
import { IBaseItemInput } from '@/interfaces/form-input'

export enum TaskStatus {
  ONGONING = 'ONGONING',
  COMPLETE = 'COMPLETE'
}

export enum TaskPriority {
  URGENT = 'Urgent',
  IMPORTANT = 'Important',
  NORMAL = 'Normal'
}

export interface History {
  id: number;
  user: ReducedUser;
  masterId: number;
  actionCode: string;
  additionalInfo: string;
  createdAt: number;
}

export interface TaskComment {
  content: string;
  creator: string;
  createdAt: string;
}

export interface Task {
  id: number;
  title: string;
  status: TaskStatus;
  priority: TaskPriority;
  dueDate: number;
  reminderDate: number;
  historyIds: number[];
  createdAt: number;
  updatedAt: number;
  assignedTo: ReducedUser[];
  createdBy: ReducedUser;
  lastModifiedBy: ReducedUser;
  histories: History[];
  notes: string;
  comments: TaskComment[];
  accounts: Account[];
  policies: Policy[];
  cases: Case[];
  relations?: TaskRelatedCell[];
}

export interface TaskInfoInput {
  title: string;
  dueDate: string;
  reminderDate: string;
  priorityIdx: number;
  assignedToList: number[] | null;
  notes: string;
}

export interface TaskRelatedCell {
  type: string;
  cell: IBaseItemInput
}

export interface TaskRelatedInput {
  typeIdx: number;
  cell: IBaseItemInput;
  lock?: boolean;
}

export interface TaskRelationInput {
  id: number;
  type: string;
}
